import isPageMeantForPwa from "../../isPageMeantForPwa";
import isIphone from "../isIphone";

(function() {
    //Removing pwa dialog
    function pwaDialogRemove(pwaInstallDialog) {
        pwaInstallDialog.className = "af-pwa-installation-dialog-hidden";
        sessionStorage.setItem("pwa", "yes");
    }
    const root = location.protocol + '//' + location.host;
    if(root.indexOf("localhost") === -1 && document.getElementById("af-pwa-installation-dialog") && isPageMeantForPwa() && window.innerWidth <= 767) {
        //Pwa install button
        const pwaInstallButton = document.getElementById("af-pwa-installation-prompt");
        //Pwa dialog
        const pwaInstallDialog = document.getElementById("af-pwa-installation-dialog");
        //Pwa close
        //const pwaCloseDialog = document.getElementById("af-pwa-installation-dialog-close");
        if(!isIphone()) {
            // Saving pwa install prompt event
            let deferredPrompt;
            //Capturing beforeinstallprompt event
            window.addEventListener('beforeinstallprompt', (e) => {
                e.preventDefault();
                deferredPrompt = e;
                if (!sessionStorage.getItem("pwa")) {
                    //Showing the prompt dialog
                    pwaInstallDialog.className = "af-pwa-installation-dialog-shown";
                }
            });
            //Hiding the installation dialog when app is installed
            window.addEventListener('appinstalled', () => {
                pwaInstallDialog.className = "af-pwa-installation-dialog-hidden";
            });
            //Prompt install
            async function afPromptPwaInstalltion() {
                deferredPrompt.prompt();
                const { outcome } =  await deferredPrompt.userChoice;
                // The deferredPrompt can only be used once.
                deferredPrompt = null;
                // Act on the user's choice
                if (outcome === 'accepted') {
                    pwaInstallDialog.className = "af-pwa-installation-dialog-hidden";
                }
            }
            pwaInstallButton.addEventListener("click",afPromptPwaInstalltion)
            //Remove pwa dialog
            //pwaCloseDialog.addEventListener("click",function() {pwaDialogRemove(pwaInstallDialog)});
        }
        else {
            //Showing the dialog for the iPhone
            pwaInstallDialog.className = "af-pwa-installation-dialog-shown";
            //Installation instruction
            const pwaInstallationInstruction = document.getElementById("af-pwa-installation-instruction");
            function afOpenInstallationDialog() {
                //Showing installation instructions
                if (pwaInstallationInstruction.className !== "af-pwa-installation-instruction-shown") {
                    pwaInstallationInstruction.className = "af-pwa-installation-instruction-shown";
                }
                else {
                    pwaInstallationInstruction.className = "af-pwa-installation-instruction-hidden";
                }
            }
            //Open installation dialog
            pwaInstallButton.addEventListener("click",afOpenInstallationDialog);
            //Remove pwa dialog
            //pwaCloseDialog.addEventListener("click",function() {pwaDialogRemove(pwaInstallDialog)});
        }
    }
})();
